export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_external.09d2376e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};